<template>
  <ion-page>
    <ion-header>
      <ion-toolbar lines="none" translucent class="menu-toolbar">
        <ion-buttons slot="end" @click="goPrev()">
          <div class="pl-05">
            <ion-icon :icon="closeOutline" size="large" />
          </div>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="menu-content" v-if="team" scroll-y="true">
      <div class="d-flex gap-10 align-items-center pl-20">
        <div class="d-flex gap-10 align-items-center">
          <TeamLogo :large="true" :team="team" />
          <div class="d-flex flex-column">
            <h1 class="c-white notranslate">{{ team?.name }}</h1>
            <span class="c-gray notranslate">{{ team?.orgtree && team?.orgtree?.club ? team?.orgtree?.club?.name : '' }}</span>
          </div>
        </div>
      </div>
      <div class="c-white pl-10 mt-10 filter-season">
        <ion-item>
          <ion-label>Filter Season</ion-label>
          <ion-select placeholder="Select One" v-model="filterSeason" @ionChange="filterSeasonChange">
            <ion-select-option v-for="filSeason in filterSeasons" :key="filSeason" :value="filSeason">{{ filSeason }}</ion-select-option>
          </ion-select>
        </ion-item>
      </div>

      <ion-grid :scroll-x="true" class="option-row ml-10" style="{'white-space': 'nowrap', 'padding-top': '1rem', background: $background !important}" nowrap>
        <ion-chip v-for="option in submenu" :key="option" @click="currentOption = option" :class="{
          'mt-20': true,
          chip: true,
          active: option === currentOption,
          selectable: option !== currentOption
        }">
          <ion-label >{{ option }}</ion-label>
        </ion-chip>
      </ion-grid>

      <section class="overview-section" v-if="currentOption === 'Overview' ">
        <div class="overview mt-20">
          <div class="overview-line">
            <div class="overview-box">
              <p class="f-bold c-white"> {{ matchesPlayed }} </p>
              <p class="c-gray">Matches Played</p>
            </div>
            <div class="overview-box">
              <p class="f-bold c-white"> {{ matchesWon }} </p>
              <p class="c-gray">Matches Won</p>
            </div>
            <div class="overview-box">
              <p class="f-bold c-white"> {{ matchesLost }} </p>
              <p class="c-gray">Matches Lost</p>
            </div>
          </div>
        </div>

        <div class="recent-match" v-if="Object.keys(latestMatch).length">
          <h2 class="c-white pl-20">Most Recent Match</h2>
          <match-card :match="latestMatch" :key="latestMatch._id" />
        </div>

        <div class="line-up p-10" v-if="!hideTeamList">
          <h2 class="c-white pl-10">Line Up</h2>
          <!-- ion list -->
          <ion-list lines="none">
            <ion-item lines="none" v-for="player in memberDetailsSeasonFiltered" :key="player._id" @click="get(player, 'isPublic', true) ? goPlayer(player._id) : null">
              <ion-avatar slot="start">
                <img :src="player.meta && get(player, 'isPublic', true) && presentation.showLogo && player.meta.imgUrl ? player.meta.imgUrl : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRt9KcSYpVsC4b1o_3v2QgaIyo3NxOk6v9eoQ&usqp=CAU'" />
              </ion-avatar>
              <ion-label>
                <h3 class="c-white">{{ get(player, 'isPublic', true) ? player.profile.firstName + ' ' + player.profile.lastName : 'Player' }}</h3>
                <p class="c-gray">{{ player.position }}</p>
              </ion-label>
              <!-- tag player type at end -->
              <ion-badge class="badge" slot="end" color="danger" v-if="checkHasExemptionImport(player)">Im</ion-badge>
              <ion-badge class="badge" slot="end" color="danger" v-if="checkHasExemptionDispensation(player)">D</ion-badge>
              <ion-badge class="c-white" slot="end">{{ getPlayerType(player._id) }}</ion-badge>
            </ion-item>
          </ion-list>
        </div>

        <div v-else class="p-10 line-up d-flex flex-column align-items-center justify-content-center">
          <h2 class="c-white pl-10">Line Up</h2>
          <p class="c-white">Team List is hidden or not yet submitted for this team</p>
        </div>
      </section>

      <section class="matches mt-10" v-if="currentOption === 'Matches' ">
        <div class="d-flex flex-column pl-10">
          <ion-item lines="none" v-if="competitions.length">
            <!-- <ion-label>Leaderboard Type</ion-label> -->
            <ion-select v-model="compFilter">
              <ion-select-option v-for="{ _id, name } in competitions" :value="_id" :key="_id">{{ name }}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item lines="none">
            <!-- <ion-label>Leaderboard Type</ion-label> -->
            <ion-select v-model="matchType" interface="popover">
              <ion-select-option v-for="type in ['Completed', 'Upcoming']" :key="type" :value="type">{{ type  }}</ion-select-option>
            </ion-select>
          </ion-item>

        </div>
        <div class="competition" v-for="{ compId, matches } in groupedByComp" :key="`comp-${compId}`">
          <div v-if="matches.length && compId === compFilter">
            <!-- <h2 class="c-white pl-20">{{ name }}</h2> -->
            <match-card :match="match" v-for="match in matches" :key="match._id" class="mb-1" />
          </div>
        </div>
      </section>

      <section class="season-summary-section" v-if="currentOption === 'Season Summary' ">
        <!-- Performance Summary Card -->
        <div class="summary-card">
          <div class="summary-card-header">
            <div class="summary-card-title">
              <span class="title-accent"></span>
              <h3>Performance By Season</h3>
            </div>
          </div>
          <div class="summary-table-wrapper" v-if="statBySeason && statBySeason.length">
            <div class="summary-table">
              <div class="summary-table-header" :style="styleGridTemplateColumns(`5.5rem 4rem`, filteredEvents.length)">
                <span class="col-label">Season</span>
                <span class="col-label">Played</span>
                <span class="col-label" v-for="stat in filteredEvents" :key="`hdr-${stat?.type}`">{{ abbreviate(stat) }}</span>
              </div>
              <div
                class="summary-table-row"
                :style="styleGridTemplateColumns(`5.5rem 4rem`, generateStat(row.matches).length)"
                v-for="row in statBySeason"
                :key="row.season"
              >
                <span class="col-season">{{ row.season }}</span>
                <span class="col-value col-played">{{ row.matches.length }}</span>
                <span class="col-value" v-for="stat in generateStat(row.matches)" :key="`${stat?.type}-${row.season}`">{{ getVal(stat, generateStat(row.matches)) }}</span>
              </div>
            </div>
          </div>

          <div class="empty-appearances" v-else>
            <p>No matches played yet.</p>
          </div>
        </div>

        <!-- Appearances Card -->
        <div class="summary-card">
          <div class="summary-card-header">
            <div class="summary-card-title">
              <span class="title-accent"></span>
              <h3>Appearances</h3>
            </div>
            <div class="comp-filter-inline" v-if="competitions.length">
              <ion-select interface="action-sheet" v-model="compFilter" placeholder="Competition" class="inline-select">
                <ion-select-option v-for="{ _id, name } in competitions" :value="_id" :key="_id">{{ name }}</ion-select-option>
              </ion-select>
            </div>
          </div>

          <div class="summary-table-wrapper" v-if="filteredMatches && filteredMatches.length">
            <div class="summary-table">
              <div class="appearances-header" :style="styleGridTemplateColumns(`2.5rem 1fr 3.5rem`, filteredEvents.length)">
                <span class="col-label">Rnd</span>
                <span class="col-label">Opponent</span>
                <span class="col-label">Score</span>
                <span class="col-label" v-for="stat in filteredEvents" :key="`app-hdr-${stat?.type}`">{{ abbreviate(stat) }}</span>
              </div>
              <div
                class="appearances-row"
                :class="{ 'row-won': heroWon(row), 'row-lost': heroLost(row), 'row-draw': !heroWon(row) && !heroLost(row) }"
                :style="styleGridTemplateColumns(`2.5rem 1fr 3.5rem`, generateStat([row]).length)"
                v-for="row in filteredMatches"
                :key="row._id"
              >
                <span class="col-round">{{ row.round?.name || row.round?.number }}</span>
                <div class="col-opponent">
                  <span class="opponent-name notranslate">{{ [get(row, 'homeTeam.name', 'N/A'), get(row, 'awayTeam.name', 'N/A')].find(t => t !== team?.name) }}</span>
                </div>
                <div class="col-score">
                  <span class="score-badge" :class="{ 'score-won': heroWon(row), 'score-lost': heroLost(row) }">
                    {{ row.scores.homeTeam }}-{{ row.scores.awayTeam }}
                  </span>
                </div>
                <span class="col-stat" v-for="stat in generateStat([row])" :key="`${stat?.type}-${row._id}`">
                  {{ getVal(stat, generateStat([row])) }}
                </span>
              </div>
            </div>
          </div>

          <div class="empty-appearances" v-else>
            <p>No matches available for this season.</p>
          </div>
        </div>
      </section>


    </ion-content>
  </ion-page>
</template>

<script>
import {
  flagOutline,
  podiumOutline,
  arrowBackOutline,
  arrowForwardOutline,
  caretDownOutline,
  menuSharp,
  closeOutline
} from "ionicons/icons";
// import { loadingController, menuController } from "@ionic/vue";
import TeamLogo from '../matches/base/team-logo.vue'
import _ from 'lodash';
import moment from 'moment';
import { isMatchHidden } from '@/utils/hide-rounds';
import MatchCard from '../../components/MatchCard.vue'
import { mapGetters } from 'vuex';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

export default {
  components: {
    TeamLogo,
    MatchCard
  },
  props: {
    entityLevel: String,
    entityName: String,
  },
  setup() {
    return {
      flagOutline,
      podiumOutline,
      arrowBackOutline,
      arrowForwardOutline,
      caretDownOutline,
      closeOutline,
      menuSharp
    }
  },
  data() {
    // const { filter } = this.$store.state.matches;
    const d = new Date();
    return {
      team: false,
      matches: [],
      key: 1,
      submenu: [
        'Overview',
        'Matches',
        'Season Summary',
      ],
      matchType: 'Completed',
      currentOption: 'Overview',
      compFilter: false,
      seasonFilter: false,
      get: _.get,
      nationalId : +process.env.VUE_APP_NATIONAL_ID,
      filterSeason: 'All',
      scoringEvents: [],
      playerMovements: [],
    };
  },
  async mounted() {
    console.log('In Team Details Page')
    const d = new Date();
    try {
      this.$store.dispatch('national/setup');
      const teamId = this.$route.params.id;
      const resTeam = await this.$http.get(`/assemble/api/v1/live/teams/${teamId}`);
      if (!resTeam.data || !resTeam.data.data) {
        this.$router.push('/teams');
        return;
      }
      this.team = resTeam.data.data.team[0];
      this.hideTeamList = resTeam.data.data.isHideTeamList;
      // this.$store.commit('national/setEntity', this.team);
      this.matches = resTeam.data.data.matches;
      this.changeDateTimeToTimezone([{
        matches: this.matches
      }]);
      this.seasonFilter = _.get(this.matches[0], 'season');
      this.compFilter = this.matches[0] ? _.get(this.matches[0], 'competition._id') : false;
      // add to top of recently viewed local storage, type team, maximum 3 items
      const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
      const newRecentlyViewed = [
        { type: 'team', entity: this.team },
        ...recentlyViewed.filter(item => item.entity._id !== this.team._id)
      ].slice(0, 5);
      localStorage.setItem('recentlyViewed', JSON.stringify(newRecentlyViewed));
      this.getEventsByTeamComps();
    } catch (error) {
      console.log(error);
    }
    // loadingController
    //   .create({ message: "Loading competitions..." })
    //   .then(loading => {
    //     loading.present();
    //   });
  },
  computed: {
    ...mapGetters('national', ['timezone']),
    entity() {
      return this.$store.getters['national/entity'];
    },
    presentation() {
      return this.$store.getters['national/presentation'];
    },
    filterSeasons() {
      const teamSeason = _.get(this.team, 'season');
      const uniqueSeasons = _.uniq(_.map(this.matches, 'season'));
      const allSeasons = _.sortedUniq(_.compact(_.uniq([teamSeason, ...uniqueSeasons])));
      allSeasons.push('All');
      return allSeasons;
    },
    filteredEvents() {
      const events = this.scoringEvents.concat(this.playerMovements).filter(e => e.visibleInLadders || e.visibleInLadders === undefined);
      if([8, 12].includes(this.nationalId)) {
        return this.reOrderEvent(events);
      }
      return events;
    },
    latestMatch() {
      // latest match with status final in the past
      let latestMatch = _.filter(this.filterSeasonMatches, match => {
        return moment(match.dateTime).isBefore(moment()) && match.status !== 'pre-game';
      });
      console.log('latestMatchs', latestMatch);
      latestMatch = _.orderBy(latestMatch, ['dateTime'], ['desc']);
      latestMatch = _.get(latestMatch, '[0]', {});
      console.log('latestMatch', latestMatch);
      return latestMatch;
    },
    memberDetailsSeasonFiltered() {
      const memberDetails = _.get(this.team, 'memberDetails', []);
      if (this.filterSeason === 'All') return memberDetails;
      const members = _.get(this.team, 'members', []).concat(_.get(this.team, 'eventMembers', [])).filter((current, index, self) => self.findIndex(t => t._id === current._id) === index);
      const seasonMembers = _.filter(members, member => member.season === this.filterSeason);
      const mappedSeasonMembersId = _.map(seasonMembers, '_id');
      const memberDetailsByMapped = _.filter(memberDetails, member => _.includes(mappedSeasonMembersId, _.get(member, '_id')));
      return memberDetailsByMapped;
    },
    filteredMatches() {
      let matches = this.filterSeasonMatches;
      matches = _.filter(matches, m => !m.meta.isBye)
      matches = _.orderBy(matches, ['round.number'], ['asc']);

      let filtered = matches;
      if (this.compFilter) {
        filtered = filtered.filter(match => _.get(match, 'competition._id') === this.compFilter);
      }

      filtered = filtered.filter((match) => {
        const hideRounds = _.get(match, 'competition.display.hideRounds', []);
        return !isMatchHidden(match, hideRounds, this.timezone);
      });

      return filtered.sort((a, b) => a.round.number - b.round.number);
    },
    matchesPlayed() {
      const matches = this.filterSeasonMatches;
      return matches.filter(match => match.status === 'final').length;
    },
    matchesWon() {
      const matches = this.filterSeasonMatches;
      const teamId = +this.$route.params.id;
      return matches
        .filter(match => {
          const isHomeTeam = _.get(match, 'homeTeam._id') === teamId;
          return match.status === 'final'
            && (isHomeTeam
              ? match.scores.homeTeam > match.scores.awayTeam
              : match.scores.awayTeam > match.scores.homeTeam
            );
        })
        .length
    },
    matchesLost() {
      const matches = this.filterSeasonMatches;
      const teamId = +this.$route.params.id;
      return matches
        .filter(match => {
          const isHomeTeam = _.get(match, 'homeTeam._id') === teamId;
          return match.status === 'final'
            && (isHomeTeam
              ? match.scores.homeTeam < match.scores.awayTeam
              : match.scores.awayTeam < match.scores.homeTeam
            );
        })
        .length
    },
    statBySeason() {
      const { seasons, matches: allMatches } = this;
      return seasons.reduce((acc, season) => {
        const matches = allMatches.filter(match => match.season === season);
        const stats = this.generateStat(matches);
        acc.push({ season, stats, matches });
        return acc;
      }, []);
    },
    filterSeasonMatches() {
      const { filterSeason, matches } = this;
      if (filterSeason === 'All') return matches;
      return matches.filter(match => match.season === filterSeason);
    },
    groupedByComp() {
      let { matchType } = this;
      let matches = this.filterSeasonMatches;
      matches = _.filter(matches, m => !m.meta.isBye)
      if (!matches) return [];
      const compIds = _.uniq(matches.map(match => _.get(match, 'competition._id')));
      let result = compIds.map(compId => {
        const competition = _.get(matches.find(m => _.get(m, 'competition._id') === compId), 'competition');
        if (!competition) return false;
        const compName = _.get(competition, 'name');
        if (_.get(competition, 'display.hideRounds', []).length && matches && matches.length) {
          matches = matches.filter((match) => {
            const hideRounds = _.get(competition, 'display.hideRounds');
            return _.get(match, 'competition._id') !== compId || !isMatchHidden(match, hideRounds, this.timezone);
          });
        }
        return {
          compId,
          name: compName,
          matches: matches
            .filter(match => _.get(match, 'competition._id') === compId)
            .filter(match => {
              if (matchType === 'Completed') {
                return match.status === 'final' || moment(match.dateTime).isBefore(moment());
              }
              return moment(match.dateTime).isAfter(moment());
            })
            .sort((a, b) => {
              // Sort by date - ascending for upcoming matches, descending for completed
              const dateA = moment(a.dateTime).valueOf();
              const dateB = moment(b.dateTime).valueOf();
              return matchType === 'Completed' ? dateB - dateA : dateA - dateB;
            })
        }
      });
      result = _.filter (result, r => r);
      return result;
    },
    competitions() {
      return this.getCompetitionsFromMatches();
    },
    seasons() {
      const uniqueSeasons = this.matches.map(match => match.season).filter((name, index, arr) => arr.indexOf(name) === index);
      return uniqueSeasons.sort((a, b) => b - a);
    },
  },
  methods: {
    changeDateTimeToTimezone(pools) {
      const timezoneClients = [21, 22];
      if (!timezoneClients.includes(+process.env.VUE_APP_NATIONAL_ID)) {
        return;
      }
      // eslint-disable-next-line no-restricted-syntax
      for (const pool of pools) {
        const { matches } = pool || {};
        // eslint-disable-next-line no-restricted-syntax
        for (const match of matches) {
          const dateTimeTimezone = utcToZonedTime(match.dateTime, this.timezone);
          match.dateTime = dateTimeTimezone.valueOf();
          match.dateTimeTimezone = dateTimeTimezone;
        }
      }
    },
    getCompetitionsFromMatches() {
      let matches = this.matches;
      if (this.filterSeason !== 'All') {
        matches = matches.filter(match => match.season === this.filterSeason);
      }
      const competitions = matches.map(match => _.get(match, 'competition')).filter(Boolean);
      return _.uniqBy(competitions, '_id');
    },
    async getEventsByTeamComps() {
      const competitions = this.getCompetitionsFromMatches();
      const mappedCompIds = _.map(competitions, '_id');
      const competitionIds = _.filter(mappedCompIds, (c) => c);
      // [POST] assemble/api/v1/live/competitions/events
      const resCompEvents = await this.$http.post('/assemble/api/v1/live/competitions/events', { competitionIds });
      const scoringEvents = _.get(resCompEvents, 'data.data.allEventsCombined.scoringEvents', []);
      const playerMovements = _.get(resCompEvents, 'data.data.allEventsCombined.playerMovements', []);
      this.scoringEvents = scoringEvents;
      this.playerMovements = playerMovements;
      console.log({
        scoringEvents,
        playerMovements
      });
    },
    checkHasExemptionImport(member) {
      const exemptionList = _.get(member, 'meta.exemptionList', []);
      return _.find((exemptionList), { type: 'import', flag: true });
    },
    checkHasExemptionDispensation(member) {
      const exemptionList = _.get(member, 'meta.exemptionList', []);
      return _.find((exemptionList), { type: 'dispensation', flag: true });
    },
    filterSeasonChange() {
      this.compFilter = _.get(this.competitions[0], '_id');
    },
    styleGridTemplateColumns(frontColumns, numColumns) {
      const style = {gridTemplateColumns: `${frontColumns} repeat(${numColumns}, 2.5rem)`};
      return style;
    },
    reOrderEvent(events) {
      if (!events || events.length === 0) return [];
      if (events.length < 6) return events;
      // G PG YC, 2M, RC and BC
      return [events[0], events[1], events[3], events[5], events[2], events[4]];
    },
    getVal(stat, matches) {
      if ((this.nationalId === 8 || this.nationalId === 12) && stat.eventName === 'Goal') {
        const getPG = matches.find((m) => m.eventName === 'Penalty Goal');

        return stat.total + getPG.total;
      }

      return stat.total;
    },
    abbreviate(stat) {
      if (stat.abbreviation) return stat.abbreviation;
      return stat?.name?.split(' ').map(s => s.charAt(0)).join('');
    },
    getPlayerType(id) {
      const { members } = this.team;
      const player = _.find(members, { _id: id });
      return _.get(player, 'memberType', '').toUpperCase();
    },
    goPrev() {
      this.$router.go(-1);
    },
    goPlayer(playerId) {
      if(this.entity && this.entityLevel && this.entityName){
        this.$router.push(`/c/${this.entityLevel}/${this.entityName}/players/${playerId}`);
        return;
      }
      this.$router.push(`/players/${playerId}`);
    },
    heroWon(row) {
      const isHomeTeam = +this.$route.params.id === _.get(row, 'homeTeam._id');
      if (isHomeTeam) return row.scores.homeTeam > row.scores.awayTeam;
      return row.scores.awayTeam > row.scores.homeTeam;
    },
    heroLost(row) {
      const isHomeTeam = +this.$route.params.id === _.get(row, 'homeTeam._id');
      if (isHomeTeam) return row.scores.homeTeam < row.scores.awayTeam;
      return row.scores.awayTeam < row.scores.homeTeam;
    },
    generateStat(matches) {
      const { scoringEvents, playerMovements } = this;
      const scorings = scoringEvents
        .filter(e => e.visibleInLadders || e.visibleInLadders === undefined)
        .reduce((acc, event) => {
          const { type, name: eventName } = event;
          const total = matches.reduce((ac, match) => {
            const { scoringEvents } = match;
            const eventTotal = scoringEvents.filter(e => e.type === type).length
            return ac + eventTotal;
          }, 0);
          return acc.concat({ type, total, eventName });
        }, [])
      const movements = playerMovements
        .filter(e => e.visibleInLadders || e.visibleInLadders === undefined)
        .reduce((acc, movement) => {
          const { type, name: movementName } = movement;
          const total = matches.reduce((ac, match) => {
            const { playerMovements } = match;
            const movementTotal = playerMovements.filter(e => e.type === type).length
            return ac + movementTotal;
          }, 0);
          return acc.concat({ type, total, movementName });
        }, [])

      const stats = scorings.concat(movements);
      if([8, 12].includes(this.nationalId)) {
        // G PG YC, 2M, RC and BC
        return this.reOrderEvent(stats);
      }
      return stats;

    },
  },
  watch:{
    currentOption:{
      handler: function(val){
        if( val=== 'Season Summary'){
          const numberOfEvents = this.filteredEvents.length;
          setTimeout(() => {
            const headers = document.querySelectorAll('.appearances-header, .summary-table-header');
            const rows = document.querySelectorAll('.appearances-row, .summary-table-row');

            headers.forEach((el) => {
              // Only override if the element uses grid columns with the old sizing
              if (el.classList.contains('appearances-header')) {
                el.style.gridTemplateColumns = `2.5rem 1fr 3.5rem repeat(${numberOfEvents}, 2.5rem)`;
              }
            });
            rows.forEach((el) => {
              if (el.classList.contains('appearances-row')) {
                el.setAttribute('style', `grid-template-columns: 2.5rem 1fr 3.5rem repeat(${numberOfEvents}, 2.5rem)`);
              }
            });
          }, 100);
        }
      },
      deep: true
    }
  }
};
</script>
<style scoped lang="scss">

ion-title {
  font-family: 'Cairo';
}

ion-grid {
  white-space: nowrap;
   --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}

/* Set the width to the full container and center the content */
ion-select {
  width: 100%;

  // justify-content: center;
}

h1, h2, h3 {
  font-family: 'Cairo';
  // margin: 0;
}

// Season Summary Enhanced Styles
.season-summary-section {
  padding: 1rem;
}

.summary-card {
  background: linear-gradient(135deg, rgba(30, 31, 34, 0.95) 0%, rgba(25, 26, 29, 0.9) 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  margin-bottom: 1.25rem;
  overflow: hidden;
}

.summary-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.25rem 0.75rem;
}

.summary-card-title {
  display: flex;
  align-items: center;
  gap: 0.6rem;

  .title-accent {
    width: 3px;
    height: 1.2rem;
    background: var(--highlight-color, #4caf50);
    border-radius: 2px;
    flex-shrink: 0;
  }

  h3 {
    color: white;
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
    letter-spacing: 0.01em;
  }
}

.comp-filter-inline {
  .inline-select {
    --color: rgba(255, 255, 255, 0.8);
    --placeholder-color: rgba(255, 255, 255, 0.5);
    font-size: 0.8rem;
    max-width: 12rem;

    &::part(text) {
      color: rgba(255, 255, 255, 0.85);
    }

    &::part(placeholder) {
      color: rgba(255, 255, 255, 0.5);
      opacity: 1;
    }

    &::part(icon) {
      color: rgba(255, 255, 255, 0.6);
      opacity: 1;
    }
  }
}

.summary-table-wrapper {
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar { display: none; }
}

.summary-table {
  min-width: fit-content;
}

.summary-table-header {
  display: grid;
  gap: 0.25rem;
  padding: 0.6rem 1.25rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.col-label {
  color: rgba(255, 255, 255, 0.45);
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.summary-table-row {
  display: grid;
  gap: 0.25rem;
  padding: 0.7rem 1.25rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  transition: background 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.03);
  }

  &:last-child {
    border-bottom: none;
  }
}

.col-season {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.col-value {
  color: white;
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.col-played {
  font-weight: 700;
  color: rgba(255, 255, 255, 0.95);
}

// Appearances styles
.appearances-header {
  display: grid;
  gap: 0.25rem;
  padding: 0.6rem 1.25rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.appearances-row {
  display: grid;
  gap: 0.25rem;
  padding: 0.85rem 1.25rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  position: relative;
  transition: background 0.15s ease;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 10%;
    height: 80%;
    width: 3px;
    border-radius: 0 2px 2px 0;
    background: rgba(255, 255, 255, 0.15);
  }

  &.row-won::before {
    background: #4caf50;
    box-shadow: 0 0 6px rgba(76, 175, 80, 0.3);
  }

  &.row-lost::before {
    background: #ef5350;
    box-shadow: 0 0 6px rgba(239, 83, 80, 0.3);
  }

  &.row-draw::before {
    background: rgba(255, 255, 255, 0.25);
  }

  &:hover {
    background: rgba(255, 255, 255, 0.03);
  }

  &:last-child {
    border-bottom: none;
  }
}

.col-round {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.75rem;
  font-weight: 500;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.col-opponent {
  display: flex;
  align-items: center;
  min-width: 0;

  .opponent-name {
    color: white;
    font-size: 0.8rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }
}

.col-score {
  display: flex;
  align-items: center;
  justify-content: center;
}

.score-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.7);
  min-width: 2.5rem;

  &.score-won {
    background: rgba(76, 175, 80, 0.15);
    color: #66bb6a;
  }

  &.score-lost {
    background: rgba(239, 83, 80, 0.15);
    color: #ef5350;
  }
}

.col-stat {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.75rem;
  font-weight: 500;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.empty-appearances {
  padding: 2.5rem 1.5rem;
  text-align: center;

  p {
    color: rgba(255, 255, 255, 0.4);
    font-size: 0.9rem;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }
}

.overview {
  padding: 1rem;
  .overview-line {
    display: flex;
    justify-content: space-between;
    @media screen and (min-width: 768px) {
      justify-content: start;
    }

    gap: 1rem;
    .overview-box {
      border-radius: 12px;
      padding: 1rem 1.5rem;
      background: #1e1f22;
      display: flex;
      flex-direction: column;
      // align-items: center;
      p { margin: 0; }
      .f-bold {
        font-size: 1.5rem;
        font-weight: bold;
      }

      .c-gray {
        font-size: 0.8rem;
      }
    }
  }
}

.option-row {
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  background: $background !important;
}

.appearance-row {
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  border-radius: 1rem;
  background: #1e1f22 !important;
}

.chip {
  font-size: 1rem;
  color: #a9a9a9;
  font-family: 'Cairo';
  &.active {
    background: var(--highlight-color);
    ion-label {
      color: #000;
    }
    // color: var(--ion-color-primary);
    font-family: 'Cairo';
  }

  &.selectable {
    cursor: pointer;
    color: #a9a9a9;
    background: #1E1F22;
  }
}

.header-bar {
  padding: 0.5rem;
}

.search-bar {
  color: #fff;
}

.round-text {
  color: #fff;
  font-family: 'Cairo';
  text-align: center;
  font-size: 14px;
  text-transform: uppercase;
  // text-decoration: underline;
  // text-decoration-color: $highlight;
}

.team-list {
  margin-top: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  padding: 0 1.5rem;
  gap: 1.5rem;
  .team-option {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

ion-label {
  color: white;
  font-family: 'Cairo';
  font-size: 0.8rem;
}


ion-item {
  --padding-start: 15px;
  --padding-end: 15px;
}

ion-badge {
  white-space: break-spaces;
}

.flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.align-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.light-text {
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
}
.normal-text {
  font-size: 15px;
  font-weight: 600;
  text-transform: capitalize;
}
.bold-text {
  font-size: 16px;
  font-weight: bold;
}
.score-text {
  font-size: 30px;
  line-height: 30px;
  font-weight: 700;
  /* color: rgba(8, 48, 109, 0.5); */
  color: white;
}

.header {
  --background: #1a2933 !important;
  color: white;
}

.custom-segment {
  background: $background !important;
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .segment-button-checked {
  color: $primary;
  --indicator-box-shadow: none;
  border-bottom: 2px solid $primary;
}

.bye-card {
  margin-inline: 1.5rem;
  position: relative;
  border-radius: 24px;
  cursor: pointer;
  box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);

  font-family: 'BrownStd-Regular';
  color: white;
  background: transparent;
  .round-text {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
}
.custom-card {
  border-radius: 24px;
  cursor: pointer;
  font-family: 'BrownStd-Regular';
  font-size: 1.2rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white;
  // background: transparent;
  box-shadow: none;
  background: #171717 !important;
  margin-inline: 1.5rem;
}
.custom-card .card-content-ios {
  padding: 10px;
}

.custom-card .promoted-header {
  font-family: 'BrownStd-Regular';
  text-align: center;
  font-size: .9rem;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: #2d3a45;
}

.list-ios, .list-md {
  padding: 0;
  background: 0;
}

ion-item {
  --background: #232528;
  --color: white;
}

.custom-segment ion-label {
  margin-bottom: 0;
}

ion-content {
  background: $background;
  --background: $background;
}

ion-content::part(scroll)::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: rgba(0,0,0,0.3);
}

ion-content::part(scroll)::-webkit-scrollbar
{
  width: .35rem;
  background-color: rgba(0,0,0,0.3);
}

@media only screen and (max-width: 768px) {
  ion-content::part(scroll)::-webkit-scrollbar {
    width: .15rem;
    background-color: rgba(0,0,0,0.3);
  }
}

ion-content::part(scroll)::-webkit-scrollbar-thumb
{
  background-color: #888;
}


.overlay {
  background: $background;
  // background: $primary;
  padding: 0rem;
}

ion-toolbar, ion-item {
  --border-width: 0 !important;
  --background: $background;
  --color: white;
}

ion-segment-button {
  --background-hover: white !important;
  --color-hover: $highlight !important;
  --color-checked: $highlight !important;
}

.custom-segment {
  border: none;
  /* background: white; */
  border-radius: 0px;
  border-bottom: 1px solid rgba(177, 177, 177, 0.3);
  padding-top: 1rem;
  border: none;
  background: none;
   display: flex;
  // justify-content: center;
  /* border-radius: 1rem !important; */
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .in-segment {
  color: rgba(177, 177, 177, 1);
  font-size: 1.3rem;
  // background-color: rgba($primary, .7);
}

.custom-segment .segment-button-checked {
  color: rgb(234 68 68);
  border-radius: 0;
  margin-bottom: 0;
  // background-color: rgba($primary, .7);
  color: $highlight;
  font-size: 1.3rem;
  font-weight: 500;
  --indicator-height: 0;
  --indicator-box-shadow: none;
  /* --indicator-color: rgb(234, 68, 68, 0.7);
  --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1); */
  border-bottom: 3px solid $highlight;
}
.custom-segment-ladder {
  // border: none;
  margin: 0 auto;
  margin-top: 1rem;
  display: flex;
  width:70%;
  justify-content: center;
  border-radius: 0.6rem !important;
}

.custom-segment-ladder-button{
  flex-basis: 50%;
}


.custom-segment-ladder ::before {
  border-left: none;
}

.custom-segment-ladder .in-segment {
  color: rgba(177, 177, 177, 1);
  background-color: rgba($primary, .2);
}

.custom-segment-ladder .segment-button-checked {
  color: rgb(234 68 68);
  // margin-bottom: 0;
  background-color: rgba($primary, .7);
  color: $highlight;
  font-weight: 400;
  // --indicator-height: 0;
  // --indicator-box-shadow: none;
  //  --indicator-color: rgb(234, 68, 68, 0.7);
  // --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1);
  // border-bottom: 3px solid $highlight;
}


.empty-container {
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-container ion-card {
  padding: 4rem;
  border-radius: 1rem;
  background: transparent;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-placeholder {
  align-items: flex-start;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  /* margin-bottom: 1rem; */
  padding-left: 0;

  letter-spacing: 0.02em;

  color: white;
}

.team-name {
  font-size: 0.8rem;
  white-space: break-spaces;
}

ion-select::part(icon) {
  margin-left: 0.5rem;
  color: white !important;
  opacity: 0.85;
}

.filter-season {
  width: 25rem;
}

.badge {
  // background: #c52828;
  background: #c52828;
  padding: 0.2rem 0.8rem;
  padding-top: 0.3rem;
  border-radius: 25%;
  font-size: small;
  margin-right: 10px;
}

</style>
